// 🔧 configure_voting.js
// ✅ Purpose: Public-facing manager guide for choosing and configuring voting
// ✅ Features:
// - Explains supported voting types
// - Helps managers choose the right voting model
// - Public and SEO-friendly
// - Uses the Dashboard-style LGV layout
// - Fully block-commented for clarity and future devs

import React from "react";
import { Link } from "react-router-dom";
import SeoHead from "../../../components/seo_head";

function ConfigureVotingGuide() {
  return (
    <section id="top-content" className="container-fluid py-5">
    <SeoHead
      title="Configure Voting Guide | Let's Go Vote"
      description="Learn how to choose and configure People’s Choice Voting, Ranked Choice Voting, Judged Points, and Scorecard judging in Let's Go Vote."
      path="/guides/configure-voting"
      breadcrumbs={[
        { name: "Home", path: "/" },
        { name: "Guides", path: "/guides" },
        {
          name: "Configure Voting",
          path: "/guides/configure-voting",
        },
      ]}
    />
      <div className="row mb-4">
        <div className="col text-start">
          <h1 className="display-5">🗳️ Configure Voting</h1>
          <p className="lead text-muted">
            Choose the voting style that best fits your event.
          </p>
        </div>
      </div>

      <div className="white-section p-4 rounded shadow-sm bg-white">
        <section className="mb-5">
          <div className="alert alert-info text-start">
            <h5 className="mb-3">Voting is the heart of the event</h5>
            <p className="mb-0">
              Let&apos;s Go Vote supports several voting styles so your event
              can use a simple public vote, a ranked ballot, or a judge-based
              scoring model.
            </p>
          </div>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">People&apos;s Choice Voting</h3>
          <p>
            People&apos;s Choice Voting is best when attendees select their
            favorite entry in each category. This is ideal for car shows, pet
            contests, art shows, community events, and public-choice awards.
          </p>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Ranked Choice Voting</h3>
          <p>
            Ranked Choice Voting allows voters to rank multiple entries in
            order of preference. This works well when you want more detailed
            voter preference than a single favorite.
          </p>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Judged Points</h3>
          <p>
            Judged Points voting is useful when judges assign numeric scores.
            This is helpful for events that need controlled scoring instead of
            public voting.
          </p>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Scorecard Judging</h3>
          <p>
            Scorecard judging supports detailed scoring factors. This works best
            when judges need to score multiple areas such as appearance,
            presentation, creativity, accuracy, or performance.
          </p>
        </section>

        <section className="mb-0">
          <div className="alert alert-primary text-start mb-0">
            <h5 className="mb-3">Next recommended guide</h5>
            <p className="mb-3">
              Once voting is selected, set up your categories and entries.
            </p>

            <Link
              to="/guides/categories-and-entries"
              className="btn btn-primary"
            >
              Continue to Categories & Entries
            </Link>
          </div>
        </section>
      </div>
    </section>
  );
}

export default ConfigureVotingGuide;